import React from 'react';
import { Alert, Snackbar } from '@mui/material';
import { useDispatch } from 'react-redux';
import { removeNotification } from '../../../actions/appNotifications';
import { useWindowSize } from '../../../utils/hooks';

export default function AppNotification({ notification, isDrawerOpen }) {
  const dispatch = useDispatch();
  const size = useWindowSize();

  const closeNotification = () => dispatch(removeNotification());

  return (
    <Snackbar
      open={notification}
      autoHideDuration={notification?.duration}
      anchorOrigin={{
        vertical: size.width > 575 ? 'top' : 'bottom',
        horizontal: size.width > 575 ? 'left' : 'center'
      }}
      onClose={closeNotification}
      sx={size.width > 575 ? { top: { sm: 20 }, left: { sm: isDrawerOpen ? 112 : 264 } } : { bottom: { xs: 90 } }}
    >
      <Alert
        severity={notification?.type}
        variant="filled"
        sx={{ minWidth: '328px', backgroundColor: '#283237', color: '#FFFFFF' }}
      >
        {notification?.message}
      </Alert>
    </Snackbar>
  );
}
